import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import type { DriverDocumentType } from '../enums/DriverDocumentType'

export class CreateUpdateDocumentsEntity {
  id?: number
  documentType?: DriverDocumentType
  document?: FileUploadEntity
  filePath?: string | null
  file?: { objectURL: string } | null
}
